const CompactLogo = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.4869 21.6305C29.4561 19.6404 30 17.4039 30 15.04C30 6.73364 23.2843 0 15 0C6.71573 0 0 6.73364 0 15.04C0 22.8193 5.89056 29.2192 13.4434 30C8.04906 28.6107 4.0625 23.7022 4.0625 17.86C4.0625 10.938 9.65894 5.32667 16.5625 5.32667C23.4661 5.32667 29.0625 10.938 29.0625 17.86C29.0625 19.1739 28.8609 20.4405 28.4869 21.6305Z"
          fill="#216869"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.8168 18.9147C26.8553 18.5526 26.875 18.1848 26.875 17.8125C26.875 12.1171 22.2579 7.5 16.5625 7.5C10.8671 7.5 6.25 12.1171 6.25 17.8125C6.25 23.5079 10.8671 28.125 16.5625 28.125C16.603 28.125 16.6434 28.1248 16.6838 28.1243C14.0369 26.9661 12.1875 24.324 12.1875 21.25C12.1875 17.1079 15.5454 13.75 19.6875 13.75C23.0143 13.75 25.8351 15.916 26.8168 18.9147Z"
          fill="#49A078"
        />
        <ellipse cx="19.6875" cy="21.25" rx="5" ry="5" fill="#1F2421" />
      </svg>
    );
  };
  export default CompactLogo;
  